import Cookies from "js-cookie";
import { OptionInterface } from "./interface";

export const EMAIL_PATTERN =  /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

export const STATUS = [
{
  value: 'REGULAR',
  name: 'Regular',
},{
  value: 'GOOD',
  name: 'Bueno',
},{
  value: 'GOOD_VERY_GOOD',
  name: 'Bueno Muy Bueno',
},{
  value: 'VERY_GOOD',
  name: 'Muy Bueno',
}];

export const SHORT_ANSWER: OptionInterface[] = [{
  value: true,
  name: 'SI',
}, {
  value: false,
  name: 'NO',
}];

export const PRICE_TYPES: OptionInterface[] = [{
  value: 'PRICE_PER_UNIT',
  name: 'Al bulto',
}, {
  value: 'PRICE_PER_KILO',
  name: 'Al kilo',
}];

export const PREGNANCY_DIAGNOSIS: OptionInterface[] = [{
  value: 'ULTRASOUND',
  name: 'Ecografia',
}, {
  value: 'TOUCH',
  name: 'Tacto',
}, {
  value: 'NONE',
  name: 'Sin diagnóstico',
}];

export const BREED_TYPES: OptionInterface[] = [{
  value: 'MEAT',
  name: 'Carnicera',
}, {
  value: 'MILK',
  name: 'Lechera',
}]

export const getLatitudes = ({
  lat,
  lng,
}: {
  lat: string,
  lng: string
}) => ({
  lat: Number(lat),
  lng: Number(lng)
});

export const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1).toLocaleLowerCase();

export const capitalizeWords = (words: string) => words.split(' ').map((word: string) => capitalizeFirstLetter(word)).join(' ');

export const convertPrice = (price: string) => price == PRICE_TYPES[0].value ? 'animal' : 'kg';

export const splitArray = (arr: any, len: number) => {
  const chunks = [], n = arr.length;
  let i = 0;

  while (i < n) {
    chunks.push(arr.slice(i, i += len));
  }

  return chunks;
}

export const concatQueryParams = (url: string) => {
  const query = window.location.hash.split("?")[1];
  if (query) {
    return `${url}?${query}`;
  }

  return url;
};

// facebook -start

export const getFbp = () => {
  var result = Cookies.get('_fbp')
  return result
}

export const getFbc = () => {
  const queryParams = getParams();
  const fbclid = queryParams?.find((param: {
    key: string,
    value: string,
  }) => param.key == 'fbclid').value;

  let value = Cookies.get('_fbc');
  if (value) {
    return value;
  } else {
    if (fbclid) {
      let ts = new Date().getTime();
      const result = `fb.1.${ts}.${fbclid}`;
      return result;
    } else {
      return undefined;
    }
  }
}

// facebook -end

export const getParams = () => window.location.hash.split("?")[1]?.split("&")?.map(param => ({key: param.split("=")[0], value: param.split("=")[1]}));

export const goTo = (url: string) => window.location.href = url;

export const emailValid = (email: string) => EMAIL_PATTERN.test(email);

export const LOGIN_TITLE = "Bienvenido";
export const SIGNUP_TITLE = "Disfrutá lo mejor de Campo Mercado";
export const FORGOT_TITLE = "¿Olvidaste tu contraseña?";

export const PHONE_NUMBERS = [
  {
    "name": "Uruguay",
    "flag": "🇺🇾",
    "code": "UY",
    "dial_code": "+598",
    "max_length": 8
    },
    {
    "name": "Argentina",
    "flag": "🇦🇷",
    "code": "AR",
    "dial_code": "+54",
    "max_length": 8
    },
    {
    "name": "Brazil",
    "flag": "🇧🇷",
    "code": "BR",
    "dial_code": "+55",
    "max_length": 11
    },
    {
    "name": "Paraguay",
    "flag": "🇵🇾",
    "code": "PY",
    "dial_code": "+595",
    "max_length": 9
    }
  ];